// import { Calendar, Filter } from 'lucide-react';

import { CalendarFilled, FilterOutlined } from "@ant-design/icons";
import { formatear, obtenerRangoMes } from "../../utils/utils";
import "./styles/filterBar.scss";

export function FilterBar({
    selectedPeriod,
    onPeriodChange,
    selectedDate,
    onDateChange,
    filterReports,
    graphData
}) {
    const formatDate = (date, period) => {
        if (period === 'day') {
            return date.toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        } else if (period === 'month') {
            return date.toLocaleDateString('es-ES', {
                month: 'long',
                year: 'numeric',
            });
        } else {
            return date.getFullYear().toString();
        }
    };

    const handlePrevious = () => {
        const newDate = new Date(selectedDate);
        if (selectedPeriod === 'day') {
            newDate.setDate(newDate.getDate() - 1);
            filterReports({ inicio: formatear(newDate), fin: formatear(newDate) }).then(() => graphData({ inicio: formatear(newDate), fin: formatear(newDate) }, selectedPeriod));
            // }
        } else if (selectedPeriod === 'month') {
            newDate.setMonth(newDate.getMonth() - 1);
            filterReports(obtenerRangoMes(newDate.getMonth() + 1, newDate.getFullYear())).then(() => graphData(obtenerRangoMes(newDate.getMonth() + 1, newDate.getFullYear()), selectedPeriod));
        } else {
            newDate.setFullYear(newDate.getFullYear() - 1);
        }
        onDateChange(newDate);


    };

    const handleNext = () => {
        const newDate = new Date(selectedDate);

        if (selectedPeriod === 'day') {
            newDate.setDate(newDate.getDate() + 1);
            filterReports({ inicio: formatear(newDate), fin: formatear(newDate) }).then(() => graphData({ inicio: formatear(newDate), fin: formatear(newDate) }, selectedPeriod));
            // }

        } else if (selectedPeriod === 'month') {
            newDate.setMonth(newDate.getMonth() + 1);
            filterReports(obtenerRangoMes(newDate.getMonth() + 1, newDate.getFullYear())).then(() => graphData(obtenerRangoMes(newDate.getMonth() + 1, newDate.getFullYear()), selectedPeriod));
        } else {
            newDate.setFullYear(newDate.getFullYear() + 1);
        }
        onDateChange(newDate);
    };

    const handleFilterChange = (newPeriod) => {
        onPeriodChange(newPeriod);

        if (newPeriod === 'day') {
            filterReports({ inicio: formatear(selectedDate), fin: formatear(selectedDate) }).then(() => graphData({ inicio: formatear(selectedDate), fin: formatear(selectedDate) }, newPeriod));
        } else {
            filterReports(obtenerRangoMes(selectedDate.getMonth() + 1, selectedDate.getFullYear())).then(() => graphData(obtenerRangoMes(selectedDate.getMonth() + 1, selectedDate.getFullYear()), newPeriod));
        }
    }

    const getButtonStyle = (active) => ({
        padding: '8px 16px',
        borderRadius: 8,
        cursor: 'pointer',
        border: 'none',
        backgroundColor: active ? '#148f9f' : '#f3f4f6',
        color: active ? '#ffffff' : '#374151',
    });

    return (
        <div
            style={{
                backgroundColor: '#ffffff',
                padding: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 16,
                width: "100%"
            }}
        >
            {/* Filtros */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 16,
                }}
            >
                <FilterOutlined style={{ fontSize: 25, color: '#148f9f' }} />

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                    }}
                >
                    <button
                        onClick={() => handleFilterChange('day')}
                        style={getButtonStyle(selectedPeriod === 'day')}
                    >
                        Día
                    </button>

                    <button
                        onClick={() => handleFilterChange('month')}
                        style={getButtonStyle(selectedPeriod === 'month')}
                    >
                        Mes
                    </button>

                    {/* <button
                        onClick={() => onPeriodChange('year')}
                        style={getButtonStyle(selectedPeriod === 'year')}
                    >
                        Año
                    </button> */}
                </div>
            </div>

            {/* Navegación fecha */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                }}
            >
                <button
                    onClick={handlePrevious}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: '#f3f4f6',
                        borderRadius: 8,
                        border: 'none',
                        cursor: 'pointer',
                        color: '#374151',
                    }}
                >
                    ←
                </button>

                <div className="filterCalendar">
                    <CalendarFilled style={{ fontSize: 16, color: '#148f9f' }} />
                    <span
                        style={{
                            color: '#1f2937',
                            fontWeight: 500,
                        }}
                    >
                        {formatDate(selectedDate, selectedPeriod)}
                    </span>
                </div>

                <button
                    onClick={handleNext}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: '#f3f4f6',
                        borderRadius: 8,
                        border: 'none',
                        cursor: 'pointer',
                        color: '#374151',
                    }}
                >
                    →
                </button>
            </div>
        </div>
    );
}